/**
 * List-marker utilities for markdown rendered OUTSIDE a `prose` block.
 *
 * Lives in its own leaf module — with no imports — so a client component can
 * use the class string without importing `MarkdownRenderer`, which would drag
 * react-markdown + the whole unified/micromark/parse5 pipeline (~318 KB raw,
 * ~102 KB brotli) into the browser bundle. `MarkdownRenderer` re-exports it, so
 * existing server-side callers are unaffected.
 */

// In prose contexts (rich_text, article_body, local_area) Tailwind Typography
// restores list markers + indent — but the plain, non-prose callers
// (`feature_card_grid`, `tabbed_content`) render bare. Spread this on the
// wrapper element around `<MarkdownRenderer>` in those contexts to bring lists
// back (hanging markers, gentle inter-item spacing) WITHOUT pulling in full
// prose typography. Do NOT add it inside a `prose` block — it would double the
// list indent.
export const MARKDOWN_LIST_STYLES =
  '[&_ul]:list-disc [&_ul]:list-outside [&_ul]:pl-5 ' +
  '[&_ol]:list-decimal [&_ol]:list-outside [&_ol]:pl-5 ' +
  '[&_li]:mb-1.5 [&_li:last-child]:mb-0'
